import React from "react";

export default function MainInfo({ handleInputChange, contract }) {
  
  return (
    <>
      <div className="carousel-item">
        <div className="mt-5 pt-4">
          <form className="container">
            <h3 className="mb-3">بيانات العقد</h3>
            <div className="row">
              <div className="col-md-4">
                <div className="mb-3">
                  <label htmlFor="start_date" className="form-label">
                    تاريخ بداية العقد
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="start_date"
                    onChange={handleInputChange}
                    value={contract.start_date}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="mb-3">
                  <label htmlFor="end_date" className="form-label">
                    تاريخ نهاية العقد
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="end_date"
                    onChange={handleInputChange}
                    value={contract.end_date}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div>
                  <label htmlFor="maintenance_visits" className="form-label">
                    {" "}
                    عدد الزيارات{" "}
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="maintenance_visits"
                    onChange={handleInputChange}
                    value={contract.maintenance_visits} 
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="d-flex justify-content-between mx-5 my-3">
          <div>
            <button
              className="btn"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev"
            >
              <span>السابق</span>
            </button>
          </div>
          <div>
            <button
              className={`btn btn-primary ${
                contract.start_date === "" ||
                contract.end_date === "" ||
                contract.maintenance_visits === null
                  ? "d-none"
                  : ""
              }`}
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next"
            >
              التالي
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
